import { ConceptoUpdateTicketCommandProps } from "api/Commands/ConceptoUpdateTicketCommand"
import { UpdateTicketCommandProps } from "api/Commands/UpdateTicketCommand"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (ticket: $TSMigrationFixMe): UpdateTicketCommandProps => {
  return {
    id: ticket?.id,
    categoria: {
      icono: ticket?.categoria?.icono,
      nombre: ticket?.categoria?.nombre,
    },
    conceptos: ticket.conceptos?.map(
      (concepto: ConceptoUpdateTicketCommandProps) => ({
        cantidad: concepto?.cantidad,
        nombre: concepto?.nombre,
        precio: concepto?.precio,
      })
    ),
    cuentasContables: {
      bancariaId:
        ticket?.contableEmpresaId ?? ticket.cuentasContables.bancariaId,
      categoriaId:
        ticket.cuentasContables?.cuentaContableId ??
        ticket?.categoria?.cuentaContableId,
    },
    empleadoId: ticket?.empleadoId,
    empresaId: ticket?.empresaId,
    fechaEmision: ticket?.fechaEmision,
    fichero: {
      ...(ticket.fichero?.ficheroAsBase64 && !ticket.fichero?.id
        ? {
            ficheroAsBase64: ticket.fichero.ficheroAsBase64,
            tipo: ticket.fichero?.tipo,
          }
        : { id: ticket.fichero?.id }),
    },
    nombre: ticket?.nombre,
    numero: ticket?.numero,
  }
}
